module.exports = __webpack_public_path__ + "static/alaundo-mtg_clb-8be823ff6a87030a3195f7485e3d6bef.jpg";